import Env from 'lib/Env';

export const API_URL = `${Env.API_URL}/games/v${Env.API_VERSION_KEYCLOAK}`;
export const FLUENCY_RECORDING_UPLOAD_URL = `${API_URL}/recordings/upload`;

const FLUENCY_API_BASE_URL = `${Env.API_URL}/fluency/v${Env.API_VERSION_KEYCLOAK}`;
export const FLUENCY_PASSAGES_URL = `${FLUENCY_API_BASE_URL}/passages`;
export const FLUENCY_PASSAGE_TEXT_URL = `${FLUENCY_API_BASE_URL}/passages/text`;
export const FLUENCY_MIC_CHECK_URL = `${FLUENCY_API_BASE_URL}/mic-check`;
export const FLUENCY_STUDENT_ASSIGNMENTS_URL = `${FLUENCY_API_BASE_URL}/student/assignments`;
export const FLUENCY_ASSIGNMENT_AUDIO_URL = `${FLUENCY_STUDENT_ASSIGNMENTS_URL}/audio`;
export const FLUENCY_ASSIGNMENT_DETAILS_URL = `${FLUENCY_STUDENT_ASSIGNMENTS_URL}/details`;
export const WORD_ANALYSIS_URL = `${FLUENCY_API_BASE_URL}/word-analysis`;

export const CLEAR_GAMESTATE_URL = `${Env.API_URL}/games/v${Env.API_VERSION_KEYCLOAK}/gameState/clear`;
export const RECOMMENDED_SKILLS_URL = `${Env.API_URL}/profiles/v${Env.API_VERSION_KEYCLOAK}`;
export const CONTENT_SERVICE_URL = `${Env.API_URL}/content/v${Env.API_VERSION_KEYCLOAK}`;
export const CLEAR_VOCAB_PROGRESS_URL = `${Env.VOCAB_API_URL}/api/students/progress/`;
export const GAME_STATE_BULK_URL = `${Env.API_URL}/games/v${Env.API_VERSION_KEYCLOAK}/gameStateBulk`;
export const VOCAB_RESULTS_URL = `${Env.API_URL}/results/v${Env.API_VERSION_KEYCLOAK}/get-recent-quest-words`;
export const TOY_URL = `${Env.API_URL}/users/v${Env.API_VERSION_KEYCLOAK}/user`;
export const PLACEMENT_URL = `${Env.API_URL}/placement/v${Env.API_VERSION_KEYCLOAK}/user`;
export const USAGE_URL = `${Env.API_URL}/results/v${Env.API_VERSION_KEYCLOAK}/usage`;
export const USAGE_TARGETS_URL = `${CONTENT_SERVICE_URL}/usage/targets`;
